import React from 'react';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { setDetailViewCard } from 'js/actions/pipelines';
import { ReactComponent as InsightsOutlined } from 'new/components/icons/InsightsOutlined.svg';
import useFlows from 'new/state/flows/repository/useFlows';
import { useFlowAdapter } from 'new/state/flows/adapter/useFlowAdapter';

import s from './FlowRunsActionsMenu.module.scss';

const handlePropagation = (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  fn: { (): void; (): void },
) => {
  e.preventDefault();
  e.stopPropagation();
  fn?.();
};

type Props = {
  flowId: number;
};

function FlowRunsActionsMenu({ flowId }: Props) {
  const dispatch = useAppDispatch();
  const { getFlowById } = useFlows();
  const { requestFlowById } = useFlowAdapter();

  const handleOpenFlowInsights = async () => {
    let flow = getFlowById(flowId);

    if (!flow) {
      const response = await requestFlowById(flowId);
      flow = response.entities.flowNodes[flowId];
    }

    dispatch(setDetailViewCard(flow, 'Insights'));
  };

  return (
    <ul className={s.actionsMenu}>
      <li>
        <button onClick={(e) => handlePropagation(e, handleOpenFlowInsights)}>
          <InsightsOutlined />
        </button>
      </li>
    </ul>
  );
}

export { FlowRunsActionsMenu };
